/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { ConversationPublishSlotStore } from 'src/luis/core/stores/ConversationPublishSlotStore';
import { PublishSlotMetadataSwagger } from 'src/luis/projects/publishPane/types/swagger/PublishSlotMetadataSwagger';
import { LuisId } from 'src/luis/types/Resource';

/**
 * Creates an publish slot store from the api received
 * app object.
 *
 * @param settings The settings object received from the api.
 * @returns An app store item.
 */
export const publishMetaDataSwaggerToPublishSlotMetaDataStore = (settings: PublishSlotMetadataSwagger) =>
    new ConversationPublishSlotStore({
        isSentimentAnalysisOn: settings.sentimentAnalysis,
        isSpeechPrimingOn: settings.speech
    });

/**
 * Creates an publish slot store from the api received
 * app object.
 *
 * @param appId The id of the App to update.
 * @param settings The setting object from the store.
 * @returns An API object.
 */
export const publishSlotMetaDataStoreToPublishMetaDataSwagger = (
    appId: LuisId,
    settings: Pick<ConversationPublishSlotStore, 'isSentimentAnalysisOn' | 'isSpeechPrimingOn'>
): PublishSlotMetadataSwagger => ({
    id: <string>appId,
    sentimentAnalysis: settings.isSentimentAnalysisOn,
    speech: settings.isSpeechPrimingOn
});
